(function(){
    /**
     * 他のJSを読み込むため、自身のファイルパスを取得する。
     **/
    var current = (function() {
        if (document.currentScript) {
            return document.currentScript.src;
        } else {
            var scripts = document.getElementsByTagName('script');
            for(var i=0; i<scripts.length; i++){
                if (scripts[i].src && scripts[i].src.indexOf('catalog-dl.js') != -1) {
                    return scripts[i].src;
                }
            }
        }
    }());
    current = current.slice(0, 1+current.lastIndexOf("/"));

    // Jqueryが読み込まれていない場合は読み込む
    if (typeof jQuery === "undefined") {
        var jqver = current+"jquery.min.js";
        loadScript(jqver, function(){});
    }

    // Jquery読み込む
    function loadScript(url, callback) {
        var done = false;
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.src = url;
        head.appendChild(script);
        script.onload = script.onreadystatechange = function() {
            if ( !done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") ) {
                done = true;
                callback();
                script.onload = script.onreadystatechange = null;
                if ( head && script.parentNode ) {
                    head.removeChild( script );
                }
            }
        };
    }

    $(window).on("load",function(){
        var dlTagList;
        $('body').find('[onclick^=catalogDl]').each(function(i,e){
            $(e).attr({'data-toggle':'modal','data-target':'#catalogDownloadModal','data-keyboard':'false'});
        });
        var modalGroupId = $("meta[name=modal-group-id]").attr("value");
        if (modalGroupId != undefined && modalGroupId != null) {
            if (modalGroupId.indexOf('/') != -1) {
                modalGroupIdChecked = modalGroupId;
            } else {
                modalGroupIdChecked = "other/0";
            }
        }
        // モーダルに必要な要素をappend
        loadDlModalDom();
    });
 
    function loadDlModalDom() {
        var modalHtml = $('<div class="c-modal modal fade" id="catalogDownloadModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"><div class="modal-dialog modal-lg modal-dialog-centered" style="width:100%; margin:0 auto;" role="document"><div class="modal-content"><div id="modal-catalog-dl"></div></div></div></div>');
        $('body').append(modalHtml);
        // モーダルの中身をappend
        catalogDlMain();
    }

    $(document).on('click','.catalogDownloadLink, #previewCatalogDownloadLink, .powerPushADownloadLink, #previewPowerPushADownloadLink, .powerPushBDownloadLink, #previewPowerPushBDownloadLink', function(e){
        e.preventDefault();
        var getCompId = $(this).data('company_id');
        var getCataId = $(this).data('catalog_id');
        catalogDl(getCompId+'_'+getCataId);
    });

    $(document).on('click','.catalogCheckedDownload', function(e){
        e.preventDefault();

        if($(this).closest(".m_bdBox").find("input[name$='_catalog_checkbox']:checked").length == 0) {
            $("#catalogAlertModalTrriger").trigger("click");
            $("#catalogAlertModal").find("h3").html("エラー");
            $("#catalogAlertModal").find("p.txt").html("カタログが選択されていません");
        } else {
            var getCataList = $(this).data('list');
            catalogDl(getCataList);
        }

    });

    // Download All for the PowerPush B "注目のカタログをすべてまとめてダウンロード"
    $(document).on('click','.catalogDownloadLinkAll', function(e){
        e.preventDefault();
        var getCataList = [];
        $(this).closest('.m_bdBox').find('.m_floatList li').each(function(){
            var getLinkElement = $('.downloadLink',this);
            getCataList.push(getLinkElement.data('company_id')+'_'+getLinkElement.data('catalog_id'));
        });
        if(getCataList.length > 0) {
            catalogDl(getCataList.join(","));
        }
    });

    $(document).on("click", "ul.catalogListUl li", function() {
        var maxAllowed = 15;
        var checkboxList = $(this).find("input[name$='_catalog_checkbox']");
        var checkCatalog = $(this).closest("ul.catalogListUl").find("input[name$='_catalog_checkbox']:checked");
        if (checkCatalog.length > maxAllowed) {
            checkboxList.prop("checked", "");
            $("#catalogAlertModalTrriger").trigger("click");
            $("#catalogAlertModal").find("h3").html("同時ダウンロード数の上限");
            $("#catalogAlertModal").find("p.txt").html("まとめてダウンロードできる上限は"+maxAllowed+"件となります。<br>さらに追加される場合は、一度ダウンロードしたうえで再度選択ください");
        } else if (checkCatalog.length == 0) {
            //$(this).closest(".m_bdBox").find(".catalogCheckedDownload").removeAttr("data-target");
        } else {
            var checkDlIdList = [];
            checkCatalog.each(function(i,e){
                checkDlIdList.push($(e).val());
            });
            $(this).closest(".m_bdBox").find(".catalogCheckedDownload").data('list',checkDlIdList.join(","));
        }
    });

}());

var modalGroupIdChecked = "", catalogDlCount = 0;

function catalogDl(cid) {
    if (catalogDlCount == 1) {
        return;
    }
    if (catalogDlCount == 0) {
        catalogDlCount = catalogDlCount + 1;
    }
    var catalogDlIntervalId = setInterval(function(){
      try {
            var dlIframe = $('#dliframe');
            if (dlIframe == undefined) {
                return;
            }

            if(dlIframe.contents().find('#userInputModal').hasClass('in') == false) {
                dlIframe.contents().find('#catalog_dl_script').attr({"onclick":"dl('"+cid+"')"});
                dlIframe.contents().find('#catalog_dl_script').trigger('click').done;
                dlIframe.contents().find('#userInputModal').find('.modal-dialog.modal-lg').css({'margin':'0px','padding':'0px','width':'100%'});
                dlIframe.contents().find('#userInputModal').find('.modal-content').css({'border':'none','border-radius':'0px','box-shadow':'none','background-color':'transparent'});
            }

            if (dlIframe[0] == undefined) {
                return;
            }

            if (dlIframe[0].contentWindow != undefined) {
                var ifrmDoc = dlIframe[0].contentWindow.document;
                var modalHtml = $('.modal-dialog', ifrmDoc);
                if (modalHtml.height() != dlIframe.css("height").replace(/[^0-9]/g,'')) {
                    dlIframe.css({"height":modalHtml.height()});
                }
            }

            if ($('#catalogDownloadModal').hasClass('show') == false) {
                clearInterval(catalogDlIntervalId);
                catalogDlCount = 0;
                dlIframe.remove();
                catalogDlMain();
            }

            if(dlIframe.contents().find('.target-1').hasClass('jsc-dn')) {
                $("#downloadStart").remove();
            }

            if(dlIframe.contents().find('body').hasClass('jsc-loading') && !$("#downloadStart")[0]) {
                var downloadStart = $('<div/>').attr("id", "downloadStart");
                downloadStart.css({"z-index":"9999","position":"absolute","top":"0","left":"0","right":"0","bottom":"0","height":$("html").get(0).scrollHeight+"px"});
                $('body').append(downloadStart);
            }
        } catch(e) {
            // モーダルを閉じるタイミングでエラーが出る場合がある
            console.log("error on catalogDl()", e);
            return;
        }
    }, 400);
}

function catalogDlMain() {
    var domain = ''; // 環境設定
    if (document.domain.indexOf("test") > -1 || document.domain.indexOf("local") > -1) {
        domain   = 'www.test.aperza.com';
    } else if (document.domain.indexOf("stg") > -1) {
        domain   = 'www.stg.aperza.com';
    } else {
        domain   = 'www.aperza.com';
    }
    $.ajax({
        type: 'POST',
        url: "https://"+domain+"/download/catalog-dl",
        data: {"modalDlGroupNameSet": modalGroupIdChecked},
        xhrFields: {
            withCredentials: true
        },
        success: function(response) {
            var iframe = document.createElement("iframe");
            iframe.className = 'dliframe';
            iframe.id = 'dliframe';
            iframe.style = 'width:100%; height:0px; border:0;';
            document.getElementById('modal-catalog-dl').appendChild(iframe);
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(response);
            iframe.contentWindow.document.close();
            $('#catalogDownloadModal').find('.modal-content').css({'border':'none','border-radius':'0px','box-shadow':'none','background-color':'transparent'});
            var dlIframe = $('#dliframe');
            dlIframe.css({"width":"100%"});

            return;
        },
        error: function(response,bb,errorThrown){
            alert(JSON.parse(response.responseText));
            location.reload();
        }
    });
}


